module.exports = __webpack_public_path__ + "static/media/PBDQ_Style_Watercolor.ffbc47e7.png";